import { render, staticRenderFns } from "./EmergencyWarning.vue?vue&type=template&id=df0f2a44&"
import script from "./EmergencyWarning.vue?vue&type=script&lang=ts&"
export * from "./EmergencyWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports